import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'search-spellcheckqueryview-view';

/**
 * We want to record a view whenever a spell-corrected term replaces a misspelled query. The parameters are 

1. Corrected query 
2. Misspelled query 
3. Request ID
 */
export function trackSearchSpellcheckqueryviewView(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
